<template>
  <div :is="elementDOM" :ref="refName" :data-name="slotName" :aria-label="label" :role="role">
    <template v-if="!isBuildWc">
      <!-- This div was added to "replicate" the presence of a webcomponent -->
      <div class="webcomponent webcomponent-simulator" :class="wrapperClass">
        <slot v-if="slotName" :name="slotName" />
        <slot v-else />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';

/**
 * `SlotContainer` - This component is a helper component that will allow us to use native slots in the webcomponents build but also use vue slots in our standalone build.
 *
 * This container must be used while wrapping a slot for the solution to be applied
 *
 * Eg. for default slot
 *
 * <SlotContainer
 *  refName="slot-sitemapsection"
 *  class="owc-footer-sitemap wb-margin-bottom-l"
 *  elementDOM="ul"
 * >
 *  <slot></slot>
 * </SlotContainer>
 *
 * Eg. for named slot
 * <SlotContainer
 *      refName="slot-lowerFooter"
 *      slotName="lowerFooter"
 *      class="wb-grid-col-mq1-12"
 *    >
 *      <slot slot="lowerFooter" name="lowerFooter" />
 *    </SlotContainer>
 *
 * CAUTION: refName should ALWAYS have "slot" in the name, so the global mixin can find the slot
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-slot-container',
  props: {
    refName: {
      type: String,
      required: true,
    },
    slotName: {
      type: String,
      required: false,
    },
    elementDOM: {
      type: String,
      default: 'div',
    },
    wrapperClass: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    role: {
      type: String,
      required: false,
    },
    isReactive: {
      type: Boolean,
      required: false,
    },
  },
  updated() {
    if (this.isReactive) {
      // Updates slot attributes when reactivity is needed in WC native slots
      this.updateSlot();
    }
  },
  data() {
    return {
      isBuildWc: process.env.BUILD === 'buildWC',
    };
  },
});
</script>
